import { Dropdown, Space, Tag } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ROUTER } from '../../../../constants/router';
import { useNavigate } from 'react-router-dom';
import useQuery from '../../../../util/useQuery';
import { ICON } from './icon';
import ModalDelete from '../../../../components/Shared/modal/delete';
import { useState } from 'react';
import useDsBreach from '../hooks/useDsBreach';
import usePermission from '../../../../hooks/usePermission';

const TagStatus = ({ status, version, latestPublishVersion }) => {
    const statusStyles = {
        Draft: { color: '#9A9A9A', borderColor: '#9A9A9A' },
        Published: { color: '#4ACE8F', borderColor: '#4ACE8F' },
    };

    const versionText = status === 'Draft' ? version : latestPublishVersion;

    if (!status || !statusStyles[status]) {
        return <div />;
    }

    return (
        <Tag
            className="rounded-xl text-center w-max"
            style={statusStyles[status]}
        >
            {status} {versionText}
        </Tag>
    );
};

export default function Card({ detail, action }) {
    const navigate = useNavigate();
    const params = useQuery();

    const [openModalDelete, setOpenModalDelete] = useState(false);

    const { deleteDataBreachForm } = useDsBreach({ isPreview: false });

    const active = params.get('id') === detail?.dataBreachGroupId;

    const items = [
        {
            key: '1',
            label: 'แก้ไขฟอร์ม',
            onClick: () =>
                navigate(
                    navigate(
                        ROUTER.DATA_BREACH.DEFAULT +
                            '/form/edit' +
                            `?id=${detail?.dataBreachGroupId}`
                    )
                ),
        },
        {
            key: '2',
            label: 'ลบฟอร์ม',
            onClick: () => setOpenModalDelete(true),
        },
    ];

    const { isAuditor, isUser } = usePermission();

    return (
        <div
            className={classNames(
                'hover:bg-[#F8F4FF] duration-300 w-full relative flex items-center',
                {
                    'bg-[#F8F4FF]': active,
                }
            )}
        >
            {active && (
                <div className="w-[6px] h-full bg-purple-PHX absolute left-0 top-0 rounded-tr-lg rounded-br-lg" />
            )}
            <button
                type="button"
                onClick={() =>
                    navigate(
                        ROUTER.DATA_BREACH.FORM +
                            `?id=${detail?.dataBreachGroupId}`
                    )
                }
                className="my-2 text-left flex flex-col p-4 w-full"
            >
                <div className="text-base font-semibold text-purple-PHX pb-2">
                    {detail?.dataBreachName}
                </div>
                <Space>
                    <TagStatus
                        status={detail?.status}
                        latestPublishVersion={detail?.latestPublishVersion}
                        version={detail?.version}
                    />
                    {detail?.isChanged && (
                        <Space className="text-[#F0536F]">
                            <svg
                                width="11"
                                height="10"
                                viewBox="0 0 11 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="5.5" cy="5" r="5" fill="#F0536F" />
                            </svg>
                            <span>มีการเปลี่ยนแปลง</span>
                        </Space>
                    )}
                </Space>
            </button>
            <Dropdown
                disabled={isAuditor || isUser}
                menu={{
                    items,
                }}
                className="disabled:opacity-50 disabled:cursor-not-allowed"
            >
                <button>{ICON[9]}</button>
            </Dropdown>
            <ModalDelete
                text="<span class='text-red-400'>หลังจากยืนยันการลบ <br /> ส่งผลให้ไม่สามารถใช้แบบฟอร์มนี้ได้อีกต่อไป</span>"
                title="ยืนยันลบส่วนนี้ ?"
                open={openModalDelete}
                handelOk={() => {
                    deleteDataBreachForm(detail?.dataBreachGroupId, action);
                    setOpenModalDelete(false);
                }}
                handelClose={() => setOpenModalDelete(false)}
            />
        </div>
    );
}

Card.propTypes = {
    detail: PropTypes.object.isRequired,
    action: PropTypes.func.isRequired,
};

TagStatus.propTypes = {
    status: PropTypes.string.isRequired,
    version: PropTypes.string.isRequired,
    latestPublishVersion: PropTypes.string.isRequired,
};
